import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import CircularProgress from '@mui/material/CircularProgress';
import {
    FormGroup,
    Label,

} from 'reactstrap';
import { NotificationManager } from 'react-notifications';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    allStudents,
    contractAddStudent,
} from 'Actions';

class AddItems extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,

    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
    }
    constructor(props) {

        super(props);
        this.state = {
            seldate: '',
            student: '',
            loader:false,
        };
    }

    selstudent = (evt) => {
        var stdid = evt.value;
        this.setState({ student: stdid });
    }


    addHandleSubmit(event) {
        event.preventDefault();
        var studid=event.target.student.value;
        var fname=event.target.clsp_1.value;

        if(studid==""&&fname==""){
            NotificationManager.error("please enter student name or select student from list");
        }else{

            this.setState({loader:true });
            this.props.contractAddStudent(event).then((data) => {
                this.setState({loader:false });
                if (data.status == 1) {
                    this.setState({
                        student: '',
                        seldate: '',
                    });

                    document.getElementById("addform").reset();
                }
            });
        }

    }


    render() {

        const { studentlists, loading } = this.props;
        const allstudent = studentlists.map((stdval) => {
            return {
                label: stdval.student,
                value: stdval.uudID
            }
        });

        const styles = {
            buttonProgress: {
                color: "blue",
                position: 'absolute',
                top: '65%',
                left: '50%',
                marginTop: -15,
                marginLeft: -15,
            },
            wrapper: {
                position: 'relative',
                textAlign:"center"
            },
        };

        return (
            <div>
                <div className="col-sm-12 col-lg-12">
                    <form autoComplete="off" id="addform" onSubmit={(e) => this.addHandleSubmit(e)}>
                        <div className="row">
                            <div className="col-sm-12 col-lg-5" style={{margin:"0 auto"}}>
                                <RctCollapsibleCard>
                                    <div className="dd">
                                        <h2 className="text-center">Student Details</h2>
                                        <div className="col-sm-12 col-lg-12">
                                            <Label for="Select" style={{fontWeight:"bold"}}>Existing Student</Label>
                                            <FormGroup>
                                                <Label for="Select" style={{fontWeight:"bold"}}>Existing Student</Label>
                                                <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student' }} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} />
                                            </FormGroup>
                                        </div>
                                        <div className="col-sm-12 col-lg-12">
                                            <div className="or-text">
                                                <p>(OR)</p>
                                            </div>
                                            <FormGroup>
                                                <Label for="country" style={{fontWeight:"bold"}}>New Student</Label>
                                            </FormGroup>    
                                            <FormGroup>
                                                <Label for="country">First Name</Label>
                                                <input type="text" name="clsp_1" id="clsp_1" className="form-control form-control-alternative" />
                                            </FormGroup>
                                        </div>
                                        <div className="col-sm-12 col-lg-12">
                                            <FormGroup>
                                                <Label for="country">Last Name</Label>
                                                <input type="text" name="smash_1" id="smash_1" className="form-control form-control-alternative" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="dd" style={{marginTop:"30px"}}> 
                                        <h2 className="text-center">Parent Details</h2>   
                                        <div className="col-sm-12 col-lg-12">
                                            <FormGroup>
                                                <Label for="country">Parent Name</Label>
                                                <input type="text" name="carry_1" id="carry_1" className="form-control form-control-alternative" required/>
                                            </FormGroup>
                                        </div>
                                        <div className="col-sm-12 col-lg-12">
                                            <FormGroup>
                                                <Label for="country">Parent Email</Label>
                                                <input type="text" name="path_1" id="path_1" className="form-control form-control-alternative" required/>
                                            </FormGroup>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group" style={styles.wrapper}> 
                                                <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader} >Submit</button>
                                                    {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}   
                                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button> 
                                            </div>                                            
                                        </div>
                                    </div>
                                </RctCollapsibleCard>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        )

    }

}

const mapStateToProps = ({ mostlyused }) => {
    const { studentlists, loading } = mostlyused;
    return { studentlists, loading };

}


export default connect(mapStateToProps, {
    allStudents,
    contractAddStudent,
})(AddItems);
